import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 * @Time 2021.12.30
 *
 * RAP
 * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=236#6674
 **/
const PickUpPoDrawerAction = {
    /**
     * 查看预约提货信息
     * @param data
     */
    getDeliveryIniti(data={}) {
        return request({
            url: '/mg/abd/whs/deliveryOrder/get-delivery-order',
            method: "POST",
            data
        });
    },

    /**
     * 申请动作
     * @param data
     */
    postHttpAction(sUrl="",data={}) {
        return request({
            url: sUrl,
            method: "POST",
            data
        });
    },

};

export default PickUpPoDrawerAction;
